<template>
    <InformeCard title="Envíos" id="envios" name="envios" collapsable="true">
        <ContentOrLoading>
            <div v-if="envios" class="row m-0">
                <div class="table-responsive width-responsive">
                    <table class="table table-hover text-nowrap">
                        <thead>
                            <tr>
                                <th>Nº de pedido</th>
                                <th>Nombre</th>
                                <th>Apellidos</th>
                                <th>Domicilio</th>
                                <th>Fecha de pedido</th>
                                <th>Fecha de envio</th>
                                <th>Estado</th>
                                <th>Gastos de envío</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="envio in envios">
                                <tr :key="envio.id">
                                    <td>{{ envio.n_pedido }}</td>
                                    <td>{{ envio.nombre }}</td>
                                    <td>{{ envio.apellidos }}</td>
                                    <td>{{ envio.domicilio }}</td>
                                    <td>{{ envio.fecha_pedido }}</td>
                                    <td>{{ envio.fecha_envio }}</td>
                                    <td>{{ envio.estado == 0 ? 'PENDIENTE' : 'ENVIADO' }}</td>
                                    <td class="pl-5">{{ envio.gastos_envio | formatear_precio }}</td>
                                    <td>{{ envio.gastos_envio | formatear_precio }}</td>
                                </tr>
                            </template>
                            <tr class="tr-total lightgray-content">
                                <td colspan="8"><strong>TOTAL</strong></td>
                                <td>{{ totales_envios.importe | formatear_precio }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </ContentOrLoading>
    </InformeCard>
</template>

<script>
    import InformeCard from "../InformeCard";

    export default {
        props: ['lista_id', 'fecha_inicio', 'fecha_fin'],
        data() {
            return {
                loading: false,
                envios: null
            }
        },
        methods: {
            getEnvios() {
                this.loading = true;

                const params = {
                    filters : {},
                    lista_id: this.lista_id
                };

                if (this.fecha_inicio && this.fecha_fin) {
                    params.filters.fecha_inicio = this.fecha_inicio;
                    params.filters.fecha_fin = this.fecha_fin;
                }

                this.$store.dispatch(this.config.getVuexAlias('back.abonos.informe.envios'), params).then(res => {
                    this.envios = res.data.data;
                }).finally(() => this.loading = false);
            },
        },
        computed: {
            totales_envios() {
                var totales = {};

                totales.importe = 0.00;

                for(var i in this.envios) {
                    totales.importe += parseFloat(this.envios[i].gastos_envio);
                }

                return totales;
            }
        },
        created() {
            this.getEnvios();
        },
        components: {
            InformeCard
        }
    }
</script>

<style scoped>
     @media (max-width: 700px) {
        .width-responsive {
            width: 288px;
        }
     }
</style>
